import * as orders from "./orders";
import * as purchases from "./purchases";

export const gshop2 = {
    ...orders,
    ...purchases,
}